import { useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    path: 'subscriber',
    context: 'selected',
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onClick() {
    // reset the intended individual deletion
    change({})

    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}

export function getText(value) {
  if (value.subscriber?.id) {
    return `Are you sure you wish to remove ${value.subscriber.employee_name} as a subscriber?`
  } else {
    return `Are you sure you wish to remove ${value.bulk_user_ids.length} subscribers?`
  }
}
